'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = init;

var _helpers = require('./_helpers');

var _utils = require('../utils');

var _swiperEsm = require('swiper/dist/js/swiper.esm.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');
  var swiperPaging = context.getElement('.' + context.className + '_Paging');

  var carousel = void 0;
  var currentSizing = void 0;

  makeCarousel();

  window.addEventListener('resize', makeCarousel);

  function makeCarousel() {
    if (currentSizing !== 'desktop' && window.innerWidth >= _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    } else if (currentSizing !== 'mobile' && window.innerWidth < _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    }

    if (window.innerWidth > _utils.mediaBreakpoints.sm) {
      currentSizing = 'desktop';
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: false,
        watchSlidesProgress: true,
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 15,
        speed: 500,
        slideClass: context.className + '_Slide',
        breakpointsInverse: true,
        breakpoints: (0, _defineProperty3.default)({}, _utils.mediaBreakpoints.md, {
          slidesPerView: 3,
          spaceBetween: 30
        }),
        pagination: {
          el: swiperPaging,
          type: 'bullets',
          clickable: true,
          bulletClass: 'sec-ArticleCarousel_Bullet',
          bulletActiveClass: 'sec-ArticleCarousel_Bullet-active'
        }
      }, [_swiperEsm.Pagination]);
    } else {
      currentSizing = 'mobile';
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: false,
        watchSlidesProgress: true,
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 15,
        speed: 500,
        slideClass: context.className + '_Slide',
        pagination: {
          el: swiperPaging,
          type: 'bullets',
          clickable: true,
          bulletClass: 'sec-ArticleCarousel_Bullet',
          bulletActiveClass: 'sec-ArticleCarousel_Bullet-active'
        }
      }, [_swiperEsm.Pagination]);
    }
  }
}